<template>
    <div
        id="assetMessage"
        :style="{ ...messageColors, ...(extendedStyle || {}) }"
        class="sc-message--text"
        v-if="getSrc()"
    >
        <span v-if="isGroupMessage" class="whatsapp-number-first" @click.stop="showWhatsappChatStarterModal = true">
            <a href="javascript:void(0)" :style="{ color: getWhatsappNumberColor() }"
                >{{ whatsappAuthorName }} - {{ whatsappAuthorNumber }}</a
            >
        </span>
        <a
            class="asset-card"
            :href="getSrc()"
            download
            target="_blank"
            v-tippy="{ followCursor: true, placement: 'bottom-end' }"
            :content="$t('message.download')"
        >
            <div class="asset-card__icon">
                <div v-if="getExt()" :class="`fi-${getExt()}`" class="fi">
                    <div class="fi-content">{{ getExt() }}</div>
                </div>
                <a-icon type="file" v-else class="asset-card__fallback-icon" />
            </div>
            <div class="asset-card__info">
                <p class="asset-card__name">{{ getAssetName() }}</p>
                <template v-if="isFilterAsset">
                    <p class="asset-card__meta">{{ $t("message.type") }}: {{ getExt() }}</p>
                    <p class="asset-card__meta">{{ $t("message.sender") }}: {{ message.raw ? message.raw.user.name : "" }}</p>
                </template>
                <p class="asset-card__ext" v-else>{{ getExt() ? getExt().toUpperCase() : "" }}</p>
            </div>
            <a-icon type="cloud-download" class="asset-card__download-icon" />
        </a>

        <div
            v-if="isGroupMessage"
            style="display: flex; flex-direction: row; justify-content: end; align-items: center; padding: 0 0.3rem"
        >
            <span class="sc-message-meta-new whatsapp-number" @click.stop="showWhatsappChatStarterModal = true">
                <a href="javascript:void(0)" :style="{ color: getWhatsappNumberColor() }"
                    >{{ whatsappAuthorName }} - {{ whatsappAuthorNumber }}</a
                >
            </span>
        </div>

        <span
            v-if="!message.isMail && message.data.meta"
            class="asset-message-meta"
            >{{ message.data.meta }}</span
        >

        <Modal2
            v-if="showWhatsappChatStarterModal"
            @cancel="showWhatsappChatStarterModal = false"
            :title="$t('message.whatsappChatStart')"
            :showFooter="false"
        >
            <WhatsappChatStarter
                :default-phone-number="whatsappAuthorNumber"
                channel-override
                phone-number-override
                @close="showWhatsappChatStarterModal = false"
                :default-name="whatsappAuthorName"
            />
        </Modal2>
    </div>
</template>

<script>
import log2 from "../../../utils/log2";
import _ from "lodash";
import Modal2 from "../../common/Modal2.vue";
import WhatsappChatStarter from "../../../views/Pages/Integrations/meta-leads/WhatsappChatStarter.vue";
import StringUtils from "../../../utils/StringUtils";

const log = log2("AssetMessage");
export default {
    name: "AssetMessage",
    props: {
        message: {
            type: Object,
            required: true,
        },
        extendedStyle: {
            type: Object,
        },
        messageColors: {
            type: Object,
            required: true,
        },
        isFilterAsset: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showWhatsappChatStarterModal: false,
        };
    },
    computed: {
        isGroupMessage() {
            return !!_.get(this.message, "raw.whatsappAuthor.author");
        },
        whatsappAuthorNumber() {
            return _.get(this.message, "raw.whatsappAuthor.author", "").replace(/[^0-9]/g, "");
        },
        whatsappAuthorName() {
            return _.get(this.message, "raw.whatsappAuthor.authorName", "");
        },
    },
    methods: {
        getAssetName() {
            const assetName = this.message?.raw?.asset?.name || "Dosyayı indir";
            return assetName;
        },
        getExt() {
            let asset = "";
            if (!!this.message.isMail) {
                asset = this.message.ext;
            } else {
                asset = this.message.raw.asset.ext;
            }
            return asset;
        },
        getSrc() {
            let asset = "";
            if (!!this.message.isMail) {
                asset = this.message;
            } else {
                asset = this.message.raw.asset;
            }
            const path = asset?.path;

            if (path) {
                const isWhatsapp = path.indexOf("whatsapp") !== -1;
                const isInstagram = path.indexOf("instagram") !== -1;
                const isMessenger = path.indexOf("messenger") !== -1;
                const isTelegram = path.indexOf("telegram") !== -1;
                const isLinkedin = path.indexOf("linkedin") !== -1;
                const isApiMessages = path.indexOf("api-messages") !== -1;

                const src =
                    isWhatsapp || isInstagram || isTelegram || isMessenger || isLinkedin || isApiMessages
                        ? `https://static.supsis.live/${path}`
                        : asset.v2Format && asset.cdnUrl
                        ? asset.cdnUrl
                        : `https://static.supsis.live/${path + asset._id + (asset.ext ? "." + asset.ext : "")}`;
                log("src", src);
                return src;
            } else {
                log("src path not found", this.message?.raw?.asset);
                return null;
            }
        },
        getWhatsappNumberColor() {
            if (this.isGroupMessage) {
                const colors = ["#1a5fb4", "#813d9c", "#c64600", "#2ec27e", "#e01b24", "#3584e4", "#9141ac", "#f5c211"];
                const index = Math.abs(this.hashCode(this.whatsappAuthorNumber)) % colors.length;
                return colors[index];
            }
            return this.messageColors.color;
        },
        hashCode(str) {
            let hash = 0;
            for (let i = 0; i < str.length; i++) {
                const char = str.charCodeAt(i);
                hash = (hash << 5) - hash + char;
                hash = hash & hash; // Convert to 32bit integer
            }
            return hash;
        },
    },
    mounted() {},
    components: {
        Modal2,
        WhatsappChatStarter,
    },
};
</script>

<style lang="scss" scoped>
@import "~css-file-icons";

#assetMessage {
    .asset-card {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px;
        padding: 8px 10px;
        margin: 4px 2px;
        background: transparent;
        border: 1px solid rgba(0, 0, 0, 0.08);
        border-radius: 10px;
        text-decoration: none;
        transition: background 0.18s ease;

        &:hover {
            background: rgba(0, 0, 0, 0.05);
            border-color: rgba(0, 0, 0, 0.15);

            .asset-card__download-icon {
                opacity: 1;
                transform: translateY(0px);
            }
        }

        &__icon {
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;

            .fi {
                font-size: 36px;
            }
        }

        &__fallback-icon {
            font-size: 28px;
            color: inherit;
            opacity: 0.6;
        }

        &__info {
            flex: 1;
            min-width: 0;
            display: flex;
            flex-direction: column;
            gap: 2px;
        }

        &__name {
            margin: 0;
            font-size: 13px;
            font-weight: 500;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 160px;
            color: inherit;
        }

        &__ext {
            margin: 0;
            font-size: 10px;
            opacity: 0.55;
            font-weight: 600;
            letter-spacing: 0.5px;
        }

        &__meta {
            margin: 0;
            font-size: 10px;
            opacity: 0.65;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 160px;
        }

        &__download-icon {
            flex-shrink: 0;
            font-size: 16px;
            opacity: 0.45;
            transform: translateY(2px);
            transition: opacity 0.18s ease, transform 0.18s ease;
            color: inherit;
        }
    }

    .fi-content {
        width: auto;
        font-size: 11px;
    }

    .asset-message-meta {
        display: block;
        text-align: left;
        font-size: 10px;
        opacity: 0.55;
        margin-top: 4px;
        padding-right: 4px;
    }

    .received {
        color: #222222;
    }

    .sent {
        color: #ffffff;
    }
}

.whatsapp-number {
    cursor: pointer;

    a {
        text-decoration: underline;
    }
}

.whatsapp-number-first {
    cursor: pointer;
    font-size: smaller;
    font-weight: 200;
    letter-spacing: 2px;

    a {
        &:hover {
            text-decoration: underline;
        }
    }

    padding: 5px;
}

.sc-message-meta-new {
    font-size: 8px;
    font-weight: 300;
    color: white;
    text-align: right;
    border-radius: 6px;
    text-transform: uppercase;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 0px !important;
    margin: 5px !important;
    margin-right: 14px !important;
    margin-bottom: 14px !important;
}
</style>
